import { h } from 'preact'
import CodeMirror from '../codemirror/'

export interface CustomHeaderData {
  html: string
}

interface Props extends CustomHeaderData {
  onChange: (header: CustomHeaderData) => void
}

const CustomHeader = ({ html, onChange }: Props) => {
  return (
    <div>
      <strong>Custom HTML</strong>
      <p>We recommend inviting a professional web developer to work with custom code. Insert code at your own risk,
        and proceed with extreme caution - inSided support won't be able to assist you with custom code issues.
        If you want to test your code before publishing we strongly recommend you to use your staging environment first.
      </p>
      <CodeMirror
        defaultValue={html}
        onChange={(newCode) => onChange({ html: newCode })}
        className='customCss__form-textarea'
      />
    </div>
  )
}

export default CustomHeader
